<template>

  <h5 class="mt-3" style="text-align: center;margin-bottom: 15px;">Bienvenido a tu sistema de ventas</h5>


  <form role="form" autocomplete="off" @submit.prevent="onSubmitSesion">
    <div class="mb-2">
      <input placeholder="Ingrese su email" class="form-control col-lg-12" required type="email" autocomplete="off"
        v-model="user.user" />
    </div>

    <div class="mb-3">
      <input placeholder="Ingrese su contraseña" class="form-control col-lg-12" required type="password"
        autocomplete="off" v-model="user.password" />
    </div>


    <div class="text-center">
      <argon-button id="log-in" ref="log-in" type="submit" class="mt-1" variant="gradient" color="success"
        style="width: 100%; background: #00b63e!important;" size="lg">{{ textoButton }}
      </argon-button>

    </div>

  </form>
</template>


<script>
/*eslint-disable */
import ArgonButton from "@/components/ArgonButton.vue";



export default {
  name: "formulario",
  components: {
    ArgonButton,
  },
  props: ['textoButton', 'isLogin'],
  data() {
    return {

      user: {
        user: '',
        password: '',
      },

      //isActive: true,
      showTerminos: false,
    }
  },

  computed: {


  },

  activated() {
    this.user.password = ''
  },

  async mounted() {

    console.log('isLogin: ' + this.isLogin)
    //this.isActive = false
    //this.showTerminos=true;
  },
  methods: {

    generaRamdom() {
      let pass = "";
      let str = "abcdefghijklmnopqrstuvwxyz";

      for (let i = 0; i < 3; i++) {
        let char = Math.floor(Math.random() * str.length);
        pass += str.charAt(char);
      }

      return pass

    },

    async onSubmitSesion(event) {
      event.preventDefault();

      try {
        const response = await this.$https.post("/system/getLogin", this.user);

        // Verifica el código de respuesta o cualquier otra lógica de negocio
        if (response.data.code !== 200) {
          throw new Error(response.data.message || "Error en la autenticación");
        }

        if (response.data.code === 200) {
          let datos = response.data.datos

          let userData = {
            user: datos.email,
            movil: datos.phone,
            ruc: datos.ruc_dni,
            companie: datos.displayNameCompanies
          }

          let companies = datos.displayNameCompanies.toLowerCase().replace(/\s+/g, "").replace(/[^a-zA-Z ]/g, "");
          let generar = this.generaRamdom()
          let senderCompanies = companies + generar
          let sessionType = this.$encryptBackoffice.encrypt(datos.role);

          localStorage.setItem('userData', JSON.stringify(userData))
          localStorage.setItem("sender", senderCompanies);
          localStorage.setItem("white", response.data.token);
          localStorage.setItem("session", sessionType); //envio la session encryptada - Administrador - Normal

          if (datos.updatePass === "true") {
            //Aqui se envia al dashboard
            console.log('Tiene actualizada la clave');
            location.reload(true);
            this.$router.push({ name: 'Dashboard' })


          } else if (datos.updatePass === "false") {
            console.log('Debe actualizar la contraseña');
            this.$router.push({ name: 'password' })
          }

        }


      } catch (error) {

        localStorage.removeItem("userData");
        localStorage.removeItem("sender");
        localStorage.removeItem("white");
        localStorage.removeItem("session");

        this.$toast.error("Ocurrió un error: " + (error.response?.data?.message || error.message), {
          position: "top-right",
          max: 10,
        });

        localStorage.removeItem("userData");

        // Puedes también manejar errores específicos, como mostrar diferentes mensajes según el tipo de error
        if (error.response) {
          console.error("Error en la respuesta del servidor:", error.response.data);
        } else if (error.request) {
          console.error("No se recibió respuesta del servidor:", error.request);
        } else {
          console.error("Error al configurar la solicitud:", error.message);
        }
      }
    },




    showSuccessToast(message) {
      this.$toast.success(message, {
        position: "bottom-right",
        max: 10
      });
    },

    showErrorToast(message) {
      this.$toast.error(message, {
        position: "bottom-right",
        max: 10
      });
    },


    async seguridadInicioSesion(nombre, movil) {
      try {

        /* console.log('seguridadInicioSesion');
        console.log(nombre);
        console.log(movil); */

        const { data } = await this.$https.post('api/auth/detallesPeticion');
        //console.log(data);

        if (data.code == 200) {

          var today = new Date();
          var now = today.toLocaleString();
          let rspt = data

          let mensaje = `Hola 🙋🏻‍♂️ *${nombre}*, le notificamos que se inició sesión a tu cuenta el *${now}* con la siguiente información:\n\n
*IP:* ${rspt.IP}\n*Dispositivo:* ${rspt.resul.nameDevice}\n*Sistema operativo:* ${rspt.resul.os} ${rspt.resul.versionOs}\n*Navegador*: ${rspt.resul.browser}\n\n
*WhatSivo + fácil + masivo* 💻📱✅`;

          //Aqui debemos de enviar un mensaje

        }
      } catch (e) {
        console.log(e.message);
      }
    }



  },
  created() {


  },
  beforeUnmount() {

  },
};
</script>

<style scoped>
.bg-gradient-success {
  background-image: linear-gradient(310deg, #5e02ca 0%, #8100d3 100%);

}



.m-input.--md .m-input-input,
.m-input.--md .m-input-label {
  font-size: 12px !important;
  line-height: 1.5rem;
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  cursor: not-allowed;
  pointer-events: auto;
}
</style>